import { Pipe, PipeTransform } from '@angular/core';
import { DocumentFieldFormatter } from '../document-field-formatter.util';

/**
 * Год урожая для показа: заданный год или null — то же правило, что в ТТН и ТрН (DocumentFieldFormatter.cropYear).
 * Чистый pipe: значение пересчитывается только при смене года, а не на каждом цикле обнаружения изменений.
 */
@Pipe({
  name: 'cropYear'
})
export class CropYearPipe implements PipeTransform {
  transform(value: number | string | null | undefined): number | null {
    return DocumentFieldFormatter.cropYear(value);
  }
}
